// @ts-nocheck
import { PagesCollectionModel } from "@insite/client-framework/Services/ContentService";
import {
    GetBlogCollectionApiParameter,
    GetBlogListApiParameter,
    getBlogSearchResults,
} from "@store/Framework/Services/BlogService";
import { getContextData } from "@store/Framework/Store/Data/Pages/PagesActionCreators";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type Parameter = GetBlogListApiParameter;
type Props = {
    apiParameter: GetBlogCollectionApiParameter;
    apiResult: PagesCollectionModel;
};

type HandlerType = Handler<Parameter, Props>;

export const DispatchBeginLoadResults: HandlerType = props => {
    props.dispatch({
        type: "Data/Pages/BeginLoadPages",
        parameter: { parentNodeId: props.parameter.id },
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        query: props.parameter.query,
        // Page size maxed out because the pagination is handled on the front-end displaying a few items at a time.
        pageSize: 999,
        page: 1,
    };
};

export const RequestDataFromApi: HandlerType = async props => {
    if (props.parameter.query) {
        props.apiResult = await getBlogSearchResults(props.apiParameter);
    } else {
        props.apiResult = {
            pages: [],
            pagination: {
                currentPage: 1,
                page: 1,
                pageSize: 12,
                defaultPageSize: 12,
                totalItemCount: 0,
                numberOfPages: 1,
                pageSizeOptions: [],
                sortOptions: [],
                sortType: "",
                nextPageUri: "",
                prevPageUri: "",
            },
        };
    }
};

export const DispatchCompleteLoadResults: HandlerType = props => {
    const state = props.getState();
    const { pages, pagination } = props.apiResult;
    props.dispatch({
        type: "Data/Pages/CompleteLoadPages",
        parameter: { parentNodeId: props.parameter.id },
        collection: {
            pages: pages || [],
            pagination,
        },
        links: state.links,
        ...getContextData(state),
    });
};

export const chain = [DispatchBeginLoadResults, PopulateApiParameter, RequestDataFromApi, DispatchCompleteLoadResults];

const loadResults = createHandlerChainRunner(chain, "LoadResults");
export default loadResults;
